// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  position: relative;
  border-right: 1px solid #e5e7eb;
  min-height: 100%;
  overflow: hidden;
  box-sizing: border-box;
}

.sidebar-visible {
  width: 20%;
}

.sidebar-hidden {
  width: 2%;
}

.sidebar-hidden-mobile {
  width: 0px;
  display: none;
}


.left-section {
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  position: relative;
}

.company-header {
  height: 10%;
  padding: 16px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.company-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.company-logo {
  width: 32px;
  height: 32px;
  background-color: #111827;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.company-logo svg {
  width: 20px;
  height: 20px;
  color: white;
}

.company-name {
  font-size: large;
  font-weight: 600;
}

.close-sidebar {
  left: 5px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 5px;
}

.start-session-container {
  height: 8%;
  padding: 8px;
}

.start-session-btn {
  width: 100%;
  background-color: #0d9488;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  gap: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.start-session-btn span {
  font-size: 20px;
}

.nav-menu {
  height: 10%;
  border-top: 1px solid #e5e7eb;
  z-index: 100;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  color: #374151;
  text-decoration: none;
}

.nav-item:hover {
  background-color: #f9fafb;
}

.nav-icon {
  width: 20px;
  height: 20px;
}

.profile-section {
  width: 20%;
  height: 8%;
  position: fixed;
  bottom: 0;
  border-top: 1px solid #e5e7eb;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile-button {
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 16px;
  background: transparent;
  border: 1px solid #a4a4a4;
  padding: 6px;
}

.profile-name-wrapper {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
}

.profile-avatar {
  width: 36px;
  height: 36px;
  background-color: #d1fae5;
  color: #059669;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.profile-select-container {
  position: absolute;
  bottom: 10px;
  right: 5px;
}

.toggle-sidebar-btn {
  position: relative;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 5px;
  top: 24px;
}

.logout-button {
  display: flex;
  gap: 10px;
  align-items: center;
  font-size: 16px;
  color: #1a1a1a;
  font-weight: 400px;
}

@media (max-width: 1024px) {
  .sidebar-visible {
    width: 26%;
  }
  .sidebar-hidden {
    width: 5%;
  }
  .company-header {
    padding: 8px;
  }
  .profile-section {
    max-width: 26%;
  }
  .profile-select-container {
    bottom: 40px;
    right: 5px;
  }
}

@media (max-width: 767px) {
  .sidebar-visible {
    width: 35%;
  }
  .sidebar-hidden {
    width: 5%;
  }
  .profile-section {
    max-width: 30%;
  }
}

@media (max-width: 600px) {
  .dashboard-container {
    border-right: none;
    padding: 10px;
  }
  .sidebar-visible {
    width: 100%;
    min-width: 100%;
  }
  .company-header {
    padding: 10px;
  }
  .company-logo {
    width: 40px;
    height: 40px;
  }
  .company-logo svg {
    width: 20px;
    height: 20px;
  }
  .company-name{
    font-size: 20px;
  }
  .profile-section {
    width: 200px;
    top: 10px;
    right: 20px;
    border-top: none;
  }
  .profile-avatar {
    width: 30px;
    height: 30px;
    font-size: 12px;
  }
  .profile-select-container {
    top: 10px;
  }
  
  .close-sidebar {
    display: none;
  }

  .start-session-container {
    height: 10%;
    padding: 10px;
  }
  .nav-menu {
    height: 13%;
    font-size: 14px;
  }
  

  .nav-item {
    gap: 5px;
    padding: 8px 10px;
  }
  .profile-name-wrapper {
    display: flex;
    gap: 6px;
    align-items: center;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboardComponent/DashboardLeftSection.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;EACR,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,UAAU;EACV,eAAe;EACf,SAAS;EACT,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,SAAS;IACT,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;EACA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,WAAW;IACX,eAAe;EACjB;;;EAGA;IACE,QAAQ;IACR,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,uBAAuB;EACzB;AACF","sourcesContent":[".dashboard-container {\n  position: relative;\n  border-right: 1px solid #e5e7eb;\n  min-height: 100%;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.sidebar-visible {\n  width: 20%;\n}\n\n.sidebar-hidden {\n  width: 2%;\n}\n\n.sidebar-hidden-mobile {\n  width: 0px;\n  display: none;\n}\n\n\n.left-section {\n  width: 100%;\n  height: 100%;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.company-header {\n  height: 10%;\n  padding: 16px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.company-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.company-logo {\n  width: 32px;\n  height: 32px;\n  background-color: #111827;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.company-logo svg {\n  width: 20px;\n  height: 20px;\n  color: white;\n}\n\n.company-name {\n  font-size: large;\n  font-weight: 600;\n}\n\n.close-sidebar {\n  left: 5px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 5px;\n}\n\n.start-session-container {\n  height: 8%;\n  padding: 8px;\n}\n\n.start-session-btn {\n  width: 100%;\n  background-color: #0d9488;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 8px 16px;\n  gap: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.start-session-btn span {\n  font-size: 20px;\n}\n\n.nav-menu {\n  height: 10%;\n  border-top: 1px solid #e5e7eb;\n  z-index: 100;\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  color: #374151;\n  text-decoration: none;\n}\n\n.nav-item:hover {\n  background-color: #f9fafb;\n}\n\n.nav-icon {\n  width: 20px;\n  height: 20px;\n}\n\n.profile-section {\n  width: 20%;\n  height: 8%;\n  position: fixed;\n  bottom: 0;\n  border-top: 1px solid #e5e7eb;\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.profile-button {\n  width: 90%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 16px;\n  background: transparent;\n  border: 1px solid #a4a4a4;\n  padding: 6px;\n}\n\n.profile-name-wrapper {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  justify-content: center;\n}\n\n.profile-avatar {\n  width: 36px;\n  height: 36px;\n  background-color: #d1fae5;\n  color: #059669;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n}\n\n.profile-select-container {\n  position: absolute;\n  bottom: 10px;\n  right: 5px;\n}\n\n.toggle-sidebar-btn {\n  position: relative;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 5px;\n  top: 24px;\n}\n\n.logout-button {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  font-size: 16px;\n  color: #1a1a1a;\n  font-weight: 400px;\n}\n\n@media (max-width: 1024px) {\n  .sidebar-visible {\n    width: 26%;\n  }\n  .sidebar-hidden {\n    width: 5%;\n  }\n  .company-header {\n    padding: 8px;\n  }\n  .profile-section {\n    max-width: 26%;\n  }\n  .profile-select-container {\n    bottom: 40px;\n    right: 5px;\n  }\n}\n\n@media (max-width: 767px) {\n  .sidebar-visible {\n    width: 35%;\n  }\n  .sidebar-hidden {\n    width: 5%;\n  }\n  .profile-section {\n    max-width: 30%;\n  }\n}\n\n@media (max-width: 600px) {\n  .dashboard-container {\n    border-right: none;\n    padding: 10px;\n  }\n  .sidebar-visible {\n    width: 100%;\n    min-width: 100%;\n  }\n  .company-header {\n    padding: 10px;\n  }\n  .company-logo {\n    width: 40px;\n    height: 40px;\n  }\n  .company-logo svg {\n    width: 20px;\n    height: 20px;\n  }\n  .company-name{\n    font-size: 20px;\n  }\n  .profile-section {\n    width: 200px;\n    top: 10px;\n    right: 20px;\n    border-top: none;\n  }\n  .profile-avatar {\n    width: 30px;\n    height: 30px;\n    font-size: 12px;\n  }\n  .profile-select-container {\n    top: 10px;\n  }\n  \n  .close-sidebar {\n    display: none;\n  }\n\n  .start-session-container {\n    height: 10%;\n    padding: 10px;\n  }\n  .nav-menu {\n    height: 13%;\n    font-size: 14px;\n  }\n  \n\n  .nav-item {\n    gap: 5px;\n    padding: 8px 10px;\n  }\n  .profile-name-wrapper {\n    display: flex;\n    gap: 6px;\n    align-items: center;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
